// src/lib/apiBase.js

// Prefer env override, otherwise fall back to sensible defaults.
const RAW_BASE =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_BASE) ||
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE) ||
  "";

// Remove trailing slashes and remove a trailing "/api" if someone put it in env by mistake.
function normalizeBase(base) {
  if (!base) return "";
  let b = String(base).trim();
  b = b.replace(/\/+$/, "");      // trim trailing /
  b = b.replace(/\/api$/i, "");   // trim trailing /api
  return b;
}

export function getApiBase() {
  const envBase = normalizeBase(RAW_BASE);
  if (envBase) return envBase;

  // Local dev fallback
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "http://localhost:5050";
  }

  // Prod fallback (your Render backend)
  return "https://streamsite-v8dd.onrender.com";
}

// Always returns a full URL to your backend, with EXACTLY ONE "/api".
export function apiUrl(path = "") {
  const base = getApiBase();
  let p = String(path || "");

  // Ensure leading slash
  if (!p.startsWith("/")) p = `/${p}`;

  // Ensure exactly one "/api" prefix
  if (!p.startsWith("/api/")) p = `/api${p}`;

  return `${base}${p}`;
}

// Fetch helper that always hits backend /api routes.
export async function apiFetch(path, options = {}) {
  const url = apiUrl(path);
  const opts = {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  };

  const res = await fetch(url, opts);

  // Try to parse JSON, but don't crash if it isn't JSON
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text || null;
  }

  if (!res.ok) {
    const message =
      (data && (data.error || data.message)) ||
      `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}
